import { useCallback, useEffect, useMemo, useState } from "react";
import {
  useGetBankLazyQuery,
  useGetBanksLazyQuery,
} from "../../../../../generated/graphql";
import { AsyncSelect } from "../../async-select/AsyncSelect";
import { AsyncSelectData } from "../../async-select/AsyncSelectData";
import { useTranslation } from "react-i18next";

interface FormikFormSelectProps {
  fieldName: string;
  labelName?: string;
  intialId?: number;
  formik;
  type?: string;
  showLabel?: boolean;
  countryId?: number;
  disabled?: boolean;
}

const FormikBankFormSelect = (props: FormikFormSelectProps) => {
  const { t } = useTranslation();

  const [getActiveBanks, { data: banks, loading: loadingBanks }] =
    useGetBanksLazyQuery({ fetchPolicy: "network-only" });

  const [getBank, { data: bank, loading: loadingBank }] = useGetBankLazyQuery({ fetchPolicy: "network-only" });

  const formikSetFieldValue = props.formik.setFieldValue;
  const [initialBank, setInitialBank] = useState<AsyncSelectData>();

  useEffect(() => {
    if (!!props.intialId) {
      getBank({
        variables: {
          id: Number(props.intialId),
        },
      });
      if (props.disabled) {
        return;
      }
    }

    if (!!props.countryId && !props.disabled) {
      getActiveBanks({
        variables: {
          name: "",
          countryId: Number(props.countryId),
        },
      });
    }
  }, [
    props?.intialId,
    getBank,
    props.disabled,
    props.countryId,
    getActiveBanks,
  ]);

  useEffect(() => {
    if (bank?.activeBanks.length) {
      let bankSelectData = new AsyncSelectData({
        title: bank?.activeBanks?.at(0)?.name,
        value: bank?.activeBanks?.at(0)?.id,
      });
        setInitialBank(bankSelectData);
        formikSetFieldValue(props?.fieldName, bank?.activeBanks?.at(0)?.id ?? 0);
    } 
  }, [
    bank?.activeBanks,
    formikSetFieldValue,
    props?.fieldName,
    props.intialId,
  ]);

  const selectedBankChanged = (data: AsyncSelectData) => {
    if (data?.value == null) {
      return;
    }
    formikSetFieldValue(props?.fieldName, data?.value);
  };

  const bankSelectOpened = useCallback(() => {
    console.log("");
  }, []);

  const bankDropData = useMemo(() => {
    return banks?.activeBanks?.map(
      (i) =>
        new AsyncSelectData({
          title: i.name,
          value: i.id,
        })
    );
  }, [banks]);

  return (
    <>
      <div>
        <AsyncSelect
          label={props.showLabel ? t("modules.formik.bank-label") : ""}
          onItemSelected={selectedBankChanged}
          onOpen={bankSelectOpened}
          defaultSelectOption={initialBank}
          data={bankDropData}
          inputValueChanged={(evt: any, value: any) => {
            getActiveBanks({
              variables: {
                name: value?.trim() ?? "",
                countryId: Number(props.countryId),
              },
            });
          }}
          loadingData={loadingBanks || loadingBank}
          disabled={props.disabled}
          hasError={Boolean(
            props.formik.errors?.[props?.fieldName] &&
              props.formik.touched?.[props?.fieldName]
          )}
          className={`w-full`}
        />
      </div>
    </>
  );
};

export { FormikBankFormSelect };
